import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.prod';

@Injectable()
export class BaseHelperUrl {
  private baseUrl = environment.API_URL;
  private prefix = environment.PREFIX;

  getBaseUrl() {
    return this.baseUrl;
  }

  getUrl() {
    return this.baseUrl + this.prefix;
  }
}
